import { Line } from "react-chartjs-2";
import { makeStyles } from "@mui/styles";
import BlockSkeleton from "../Skeleton/BlockSkeleton";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

const useStyles = makeStyles({
  root: {
    height: "100%",
  },
});

function LineGraph({ data, title, loading }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {loading ? (
        <BlockSkeleton />
      ) : (
        <Line
          data={data}
          options={{
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false,
              },
              title: {
                display: true,
                text: title,
                color: "#58595b",
                font: {
                  size: 16,
                  family: "Arial",
                },
              },
            },
            scales: {
              y: {
                min: 0,
              },
            },
          }}
        />
      )}
    </div>
  );
}

export default LineGraph;
